var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-index frame-content-common-2022"},[_c('div',{staticClass:"pageTitleBlock"},[_c('h2',{staticStyle:{"margin-left":"16px"}},[_vm._v("Dashboard")])])])
}]

export { render, staticRenderFns }